import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import Hoc from "../../components/HOC";
import RadioOption from "../../components/RadioOption/index";
import Projects from "./Projects/index";
import Budget from "./Budget/index";

const Reports = () => {
   return (
    <div className="relative h-[80vh] bg-white-100  w-[48rem] ">
   <div className="p-6">Timesheets Data</div>
    </div> 
  );
};

export default Hoc(Reports);
